// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"bdfb4b2e","88":"7d46732a","806":"f0fa48c0"}[chunkId] + ".chunk.js";
};